// src/pages/vendas/CancelarNFModal.js
import React, { useEffect, useState } from 'react';
import { useMessage } from '../../contexts/geral/MessageContext'; // Supondo que tenha o contexto de mensagens
import Modal from '../../components/modalForm/StackedBootstrapModal';
import Button from 'react-bootstrap/Button';
// Supondo que já tenha este serviço
import { cancelarNotaFiscal, excluirRecibo } from '../../services/vendas/NotaFiscalService';

const CancelarNFModal = ({ show, onHide, notaId, modeloDoc, situacaoNF, onCancelSuccess }) => {
    const [motivo, setMotivo] = useState('');
    const [cancelando, setCancelando] = useState(false);
    const { showMessage } = useMessage();
    const excluindoRecibo = Number(situacaoNF) === 9;
    const modeloNormalizado = String(modeloDoc || '').toUpperCase();
    const descricaoDocumento = excluindoRecibo
        ? 'Recibo'
        : modeloNormalizado === 'NFSE'
        ? 'NFS-e'
        : modeloNormalizado === '55'
            ? 'NF-e'
            : 'NFC-e';

    useEffect(() => {
        if (show) setMotivo('');
    }, [show, notaId]);

    const handleCancel = async () => {
        const motivoNormalizado = motivo.trim();

        const tamanhoMaximo = excluindoRecibo ? 1000 : 255;
        if (motivoNormalizado.length < 15 || motivoNormalizado.length > tamanhoMaximo) {
            showMessage(
                `A justificativa deve ter entre 15 e ${tamanhoMaximo} caracteres.`,
                'danger',
            );
            return;
        }

        setCancelando(true);

        try {

            if (excluindoRecibo) {
                await excluirRecibo({ notaId, justificativa: motivoNormalizado });
                showMessage('Recibo excluído com sucesso.', 'success');
            } else {
                await cancelarNotaFiscal({
                    notaId,
                    modeloDoc,
                    motivoCancelamento: motivoNormalizado,
                });
                showMessage(`${descricaoDocumento} cancelada com sucesso.`, 'success');
            }
            
            onCancelSuccess(); // Callback para atualizar a lista de notas
            onHide(); // Fecha o modal
        } catch (error) {
            showMessage(error.message, 'danger');
        } finally {
            setCancelando(false);
        }
    };

    return (
        <Modal show={show} onHide={onHide}>
            <Modal.Header closeButton>
                <Modal.Title>{excluindoRecibo ? 'Excluir' : 'Cancelar'} {descricaoDocumento}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <label>{excluindoRecibo ? 'Justificativa da exclusão:' : 'Motivo do cancelamento:'}</label>
                    <textarea
                        value={motivo}
                        onChange={(e) => setMotivo(e.target.value)}
                        rows={4}
                        maxLength={excluindoRecibo ? 1000 : 255}
                        className="form-control"
                    />
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Fechar
                </Button>
                <Button
                    variant="danger"
                    onClick={handleCancel}
                    disabled={cancelando}
                >
                    {cancelando
                        ? (excluindoRecibo ? 'Excluindo...' : 'Cancelando...')
                        : `${excluindoRecibo ? 'Excluir' : 'Cancelar'} ${descricaoDocumento}`}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default CancelarNFModal;
